import { render, staticRenderFns } from "./PatternSidebarItem.vue?vue&type=template&id=4a20691c&"
import script from "./PatternSidebarItem.vue?vue&type=script&lang=js&"
export * from "./PatternSidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./PatternSidebarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports